import apiClient from '@/lib/api';
import type { Entity } from '@/types';

export async function listEntities(): Promise<Entity[]> {
  const { data } = await apiClient.get('/entities');
  return data.data ?? data;
}

/** Admin listing: includes hidden entities and entities in hidden divisions. */
export async function listAllEntities(): Promise<Entity[]> {
  const { data } = await apiClient.get('/entities', {
    params: { includeHidden: 'true', pageSize: 200 },
  });
  return data.data ?? data;
}

export async function getEntity(id: string): Promise<Entity> {
  const { data } = await apiClient.get(`/entities/${id}`);
  return data.data ?? data;
}

export async function updateEntity(
  id: string,
  patch: Partial<Pick<Entity, 'isHidden' | 'qlikName' | 'name' | 'fyStartMonth'>>,
): Promise<Entity> {
  const { data } = await apiClient.patch(`/entities/${id}`, patch);
  return data.entity ?? data;
}

/** Trigger an immediate master-data sync from the month-end close app. */
export type MonthendSyncSummary = {
  divisions: { created: number; updated: number; unmatchedLocal: string[] };
  entities: {
    created: number;
    updated: number;
    unmatchedLocal: string[];
    needQlikName: string[];
  };
};

export async function syncEntitiesNow(): Promise<MonthendSyncSummary> {
  const { data } = await apiClient.post('/entities/sync');
  return data.summary;
}
